import React, { useState } from "react";
import "./BlogSection.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

// Import your blog images
import blogImage1 from "../../Images/blog1.jpg"; // Replace with your actual image paths
import blogImage2 from "../../Images/blog2.jpg";
import blogImage3 from "../../Images/blog3.jpg";

const blogData = [
  {
    id: 1,
    title: "Beauty Hub: Tips, Trends & Tutorials",
    description:
      "Stay in the glow with expert tips, how-tos, and the latest beauty trends. Whether you're mastering a bold lip or building a skincare routine that actually works, we've got the guidance, product insights, and glow-up secrets you need.",
    image: blogImage1,
  },
  {
    id: 2,
    title: "Skincare Science: What Really Works",
    description:
      "Dive deep into the science behind skincare ingredients and discover what truly makes a difference. From retinol to hyaluronic acid, we break down the formulas that transform your skin and separate fact from fiction.",
    image: blogImage2,
  },
  {
    id: 3,
    title: "Makeup Mastery: Pro Techniques Made Easy",
    description:
      "Learn professional makeup techniques from industry experts. Master the art of contouring, discover the perfect eyeshadow blend, and unlock secrets to long-lasting makeup that looks flawless all day long.",
    image: blogImage3,
  },
];

const BlogSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? blogData.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === blogData.length - 1 ? 0 : prev + 1));
  };

  const currentBlog = blogData[currentIndex];

  return (
    <section className="blog-section">
      <div className="blog-header">
        <h1>Blog</h1>
      </div>

      <div className="blog-content">
        <div className="blog-image-container">
          <img src={currentBlog.image} alt={currentBlog.title} />
          <button className="blog-nav-btn blog-prev" onClick={handlePrev}>
            <FaArrowLeft />
          </button>
        </div>

        <div className="blog-text-container">
          <h2>{currentBlog.title}</h2>
          <p>{currentBlog.description}</p>
          <button className="blog-read-btn">
            READ <FaArrowRight className="read-arrow" />
          </button>
          <button className="blog-nav-btn blog-next" onClick={handleNext}>
            <FaArrowRight />
          </button>

          <div className="blog-dots">
            {blogData.map((_, index) => (
              <span
                key={index}
                className={`dot ${index === currentIndex ? "active" : ""}`}
                onClick={() => setCurrentIndex(index)}
              ></span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
